// export const CORE_API_ENDPOINT = 'https://www.bainisysstg.com/core'
// export const O365_API_ENDPOINT = 'https://www.bainisysstg.com/o365'
// export const NOTI_API_ENDPOINT = 'https://www.bainisysstg.com/notification'

// export const CORE_API_ENDPOINT = 'http://10.0.10.17:2000/core'
// export const O365_API_ENDPOINT = 'http://10.0.10.17:3000/o365'
// export const NOTI_API_ENDPOINT = 'http://10.0.10.17:3001/notification'

export const PROFILE_CENTER_URL = 'https://backoffice.bsrsprofile.com/api'

// export const CORE_API_ENDPOINT = 'https://back26.rmbainisys.com/core'
// export const O365_API_ENDPOINT = 'https://back26.rmbainisys.com/o365'
// export const NOTI_API_ENDPOINT = 'https://back26.rmbainisys.com/notification'

// export const CORE_API_ENDPOINT = 'https://back23.rmbainisys.com/core'
// export const O365_API_ENDPOINT = 'https://back23.rmbainisys.com/o365'
// export const NOTI_API_ENDPOINT = 'https://back23.rmbainisys.com/notification'

// server 10.0.30.9
export const CORE_API_ENDPOINT = '/core'
export const O365_API_ENDPOINT = '/o365'
export const NOTI_API_ENDPOINT = '/notification'

// export const CORE_API_ENDPOINT = 'https://frontgg.rmbainisys.com/core'
// export const O365_API_ENDPOINT = 'https://frontgg.rmbainisys.com/o365'
// export const NOTI_API_ENDPOINT = 'https://frontgg.rmbainisys.com/notification'

// export const CORE_API_ENDPOINT = 'https://backssr.rmbainisys.com/core'
// export const O365_API_ENDPOINT = 'https://backssr.rmbainisys.com/o365'
// export const NOTI_API_ENDPOINT = 'https://backssr.rmbainisys.com/notification'

// export const CORE_API_ENDPOINT = 'http://localhost:2140/core'
// export const O365_API_ENDPOINT = 'http://localhost:2141/o365'
// export const NOTI_API_ENDPOINT = 'http://localhost:2142/notification'

// export const CORE_API_ENDPOINT = 'https://siricampusmeetingrm.sansiri.com/core'
// export const O365_API_ENDPOINT = 'https://siricampusmeetingrm.sansiri.com/o365'
// export const NOTI_API_ENDPOINT = 'https://siricampusmeetingrm.sansiri.com/notification'


//// จะ ปิด เมนู role room ที่ user หรือไม่
export const IS_SYNC_O365_GROUP_AND_PERMISSION = false
    // FUJITSU Smart Workplace Meeto
    // Bainisys Smart Reservation System(BSRS)
export var pageTitle = "Bainisys Smart Reservation System(BSRS)"

// BAINISYS
//FUJITSU
export const COPYRIGHT = '© 2019 BAINISYS'

//// meetup, central, roomminister
export const LOGO_THEME = "roomminister"



// WEBPACK FOOTER //
// ./src/lib/api.js